module.exports = __webpack_public_path__ + "static/media/sector-data_top_min.28bb81f7.jpg";